// extracted by mini-css-extract-plugin
export default {"button":"RowAction_button__WdibV","danger":"RowAction_danger__gV5ck"};